var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheckBlue = function SvgCircleCheckBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-check-blue_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8Z",
    fill: "#214FB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 8.762 3.38-3.381 1.238 1.237-4 4a.877.877 0 0 1-1.237 0l-2-2 1.237-1.237L7 8.762Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-check-blue_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgCircleCheckBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExNV80MzkpIj4KPHBhdGggZD0iTTAgOEMwIDMuNTgxMjUgMy41ODEyNSAwIDggMEMxMi40MTg3IDAgMTYgMy41ODEyNSAxNiA4QzE2IDEyLjQxODcgMTIuNDE4NyAxNiA4IDE2QzMuNTgxMjUgMTYgMCAxMi40MTg3IDAgOFoiIGZpbGw9IiMyMTRGQjciLz4KPHBhdGggZD0iTTYuOTk5NjEgOC43NjIxMUwxMC4zODA5IDUuMzgwODZMMTEuNjE4NCA2LjYxODM2TDcuNjE4MzYgMTAuNjE4NEM3LjI3NzczIDEwLjk1OSA2LjcyMTQ4IDEwLjk1OSA2LjM4MDg2IDEwLjYxODRMNC4zODA4NiA4LjYxODM2TDUuNjE4MzYgNy4zODA4Nkw2Ljk5OTYxIDguNzYyMTFaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzExNV80MzkiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";